// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"536":"10b0e446","543":"f8da34ab","663":"cc2f2d3e","862":"e7f67d9b"}[chunkId] + ".chunk.css";
};